// Mobile sticky CTA: appears once the device section is scrolled past, hides while the closing offer is on screen.
(() => {
  const sticky = document.querySelector('.hf-sticky');
  const trigger = document.getElementById('hsa-fsa-devices');
  const offer = document.getElementById('hsa-fsa-offer');
  if (!sticky || !trigger || !offer) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let scheduled = false;
  function update() {
    scheduled = false;
    const offerBox = offer.getBoundingClientRect();
    const offerVisible = offerBox.top < window.innerHeight && offerBox.bottom > 0;
    sticky.hidden = !mobile.matches || trigger.getBoundingClientRect().bottom > 0 || offerVisible;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();

// Show the visitor's current date, including after returning to an open tab.
(() => {
  const dates = document.querySelectorAll('[data-current-date]');
  if (!dates.length) return;
  function refreshDate() {
    const now = new Date();
    const label = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(now);
    const value = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    dates.forEach(date => { date.textContent = label; date.dateTime = value; });
  }
  refreshDate();
  setInterval(refreshDate, 60000);
  document.addEventListener('visibilitychange', refreshDate);
})();
